import React from 'react';
import { Text } from '@topconagriculture/react-components';
import { ToDoIcon } from './ToDoIcon';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
export const useStyles = makeStyles({
    noAlerts: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: 'fit-content',
        width: 'fit-content',
        margin: 'auto auto',
        textAlign: 'center',
        '& svg': {
            margin: '0 auto',
        },
    },
});
export const NoAlerts = () => {
    const { t } = useTranslation();
    const classes = useStyles();
    return (React.createElement("div", { className: classes.noAlerts },
        React.createElement(ToDoIcon, null),
        React.createElement(Text, { block: true, bold: true }, t('widget:inventory:no_inventory_alerts')),
        React.createElement(Text, { block: true }, t('widget:inventory:no_warnings'))));
};
//# sourceMappingURL=NoAlerts.js.map